import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCurrentUser } from "../services/authService";

const Dashboard = () => {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const user = await getCurrentUser();
        setRole(user.role);
      } catch (err) {
        console.log("Не вдалося отримати роль користувача", err);
      }
    };
    fetchRole();
  }, []);

  return (
    <div className="p-6 bg-[#F5F0E6] min-h-screen">
      <h2 className="text-2xl font-bold text-[#4B2E2B] mb-6">
        Панель управління
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Link
          to="/products"
          className="bg-white shadow-lg rounded-lg p-6 text-center border border-[#D2B48C] hover:bg-[#FAF3E0] transition"
        >
          <h3 className="text-xl font-semibold text-[#4B2E2B] mb-2">Товари</h3>
          <p className="text-gray-600">Управління дерев'яними товарами</p>
        </Link>

        <Link
          to="/categories"
          className="bg-white shadow-lg rounded-lg p-6 text-center border border-[#D2B48C] hover:bg-[#FAF3E0] transition"
        >
          <h3 className="text-xl font-semibold text-[#4B2E2B] mb-2">Категорії</h3>
          <p className="text-gray-600">Управління категоріями</p>
        </Link>



        <Link
          to="/inquiries"
          className="bg-white shadow-lg rounded-lg p-6 text-center border border-[#D2B48C] hover:bg-[#FAF3E0] transition"
        >
          <h3 className="text-xl font-semibold text-[#4B2E2B] mb-2">
            Запити користувачів
          </h3>
          <p className="text-gray-600">
            Перегляд повідомлень з контактної форми
          </p>
        </Link>


        <Link
          to="/gallery"
          className="bg-white shadow-lg rounded-lg p-6 text-center border border-[#D2B48C] hover:bg-[#FAF3E0] transition"
        >
          <h3 className="text-xl font-semibold text-[#4B2E2B] mb-2">
            Управління галереєю
          </h3>
          <p className="text-gray-600">
            Перегляд галереї
          </p>
        </Link>

          <Link
          to="/settings"
          className="bg-white shadow-lg rounded-lg p-6 text-center border border-[#D2B48C] hover:bg-[#FAF3E0] transition"
        >
          <h3 className="text-xl font-semibold text-[#4B2E2B] mb-2">
            Управління контентом
          </h3>
          <p className="text-gray-600">
            Перегляд секцій
          </p>
        </Link>
        {/* Показувати тільки якщо супер-адмін */}
        {role === "superadmin" && (
          <Link
            to="/admins"
            className="bg-white shadow-lg rounded-lg p-6 text-center border border-[#D2B48C] hover:bg-[#FAF3E0] transition"
          >
            <h3 className="text-xl font-semibold text-[#4B2E2B] mb-2">
              Адміністратори
            </h3>
            <p className="text-gray-600">
              Управління адміністраторами (тільки для супер-адміну)
            </p>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
